export const AlertMessageDialogActionType = {

    OPEN_ALERT_MESSAGE_DIALOG: 'OPEN_ALERT_MESSAGE_DIALOG',
    CLOSE_ALERT_MESSAGE_DIALOG: 'CLOSE_ALERT_MESSAGE_DIALOG',
};
